<template>
  <div class="taskPackage">
    <div class="top">
      计划包
    </div>
    <div class="content">
      <div class="contentLeft">
        <div class="contentLeftTop">
          <p @click="addTaskPackage">新建</p>
        </div>
        <div class="contentLeftLi">
          <ul>
            <li v-for="(item, index) in taskPackageList" :key="index" :class="[item.packageId === cur ? 'active' : '']"
              @click="clickLi(item)">
              <p :title="item.packageName" class="packageName"> {{ item.packageName }} </p>
              <div class="operation">
                <i v-show="item.packageId === cur" class="el-icon-more">
                  <el-popover :key="item.packageId" popper-class="secondUserIDs" placement="bottom-start"
                    trigger="hover">
                    <div class="elasticbox">
                      <p @click="editTaskPackage">编辑</p>
                      <p @click="delTaskPackage(item)">删除</p>
                      <p @click="moveTaskPackage(item,1,index)">上移</p>
                      <p @click="moveTaskPackage(item,2,index)">下移</p>
                    </div>
                    <p slot="reference" style="width: 3px; height: 13px"></p>
                  </el-popover>
                </i>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="contentRight">
        <div class="contentRightTop">
          <p>
            <el-button :disabled="!cur" type="primary" size="small" icon="el-icon-plus" @click="toRelease">新增</el-button>
          </p>
          <el-input v-model="input1" placeholder="请输入计划名称" class="input-with-select"
            style="width: 200px; margin-left: 10px" size="small">
            <i slot="suffix" class="el-icon-search" />
          </el-input>
        </div>
        <div class="contentRightTable">
          <el-table ref="multipleTable" border :data="tableData1" tooltip-effect="dark" height="100%" style="width: 100%"
            row-key="taskId" :tree-props="{ children: 'nodeList' }" highlight-current-row default-expand-all class="treeTab">
            <template slot="empty">
              <img :src="zanwu" alt="" />
              <p style="font-size:16px;color:#000;">暂无数据</p>
            </template>
            <el-table-column label="名称" prop="taskName" width="120">
              <template #default="{ row }">
                <el-link type="primary" @click="lookRow(row)">
                  <span class="tabLinkSpan" :title="row.taskName">{{ row.taskName }}</span>
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="planSchedule" label="工期" show-overflow-tooltip align="center" />
            <el-table-column prop="originalSpecName" label="专业" show-overflow-tooltip align="center" />
            <el-table-column prop="flowTempName" label="关联流程" show-overflow-tooltip align="center" />
            <el-table-column prop="preTaskName" label="紧前计划" show-overflow-tooltip />
            <el-table-column prop="afterTaskName" label="紧后计划" show-overflow-tooltip />
            <el-table-column prop="isMilestone" label="里程碑" show-overflow-tooltip align="center">
              <template #default="{ row }">
                <span>{{ ["否", "是"][row.isMilestone] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="taskTypeName" label="计划类型" show-overflow-tooltip />
            <el-table-column label="操作" align="center" width="180">
              <template slot-scope="scope">
                <i class="el-icon-ziji" title="添加子级" @click.stop="childAdd(scope.row)"></i>
                <i class="el-icon-edit" title="编辑" @click.stop="editrow(scope.row)"></i>
                <i class="el-icon-del" title="删除" @click.stop="delrow(scope.row)"></i>
                <i class="el-icon-shangyi" title="上移" @click.stop="tableMove(scope.row,'0')"></i>
                <i class="el-icon-xiayi" title="下移" @click.stop="tableMove(scope.row,'1')"></i>
                <i class="el-icon-shengji" title="升级" @click.stop="upgrade(scope.row,'0')"></i>
                <i class="el-icon-jiangji" title="降级" @click.stop="demotion(scope.row,'1')"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 计划包添加 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="addTaskPackageOpen" :title="taskPackageNameTitle" width="27%" top="25vh"
      custom-class="addTaskPackageMerge">
      <div class="packageName">
        <el-form ref="taskPackageMergeForm" :model="taskPackageMergeForm" label-position="top" label-width="110px" :rules="taskPackageMergeRules" size="small">
          <el-form-item label="请输入计划包名称:" prop="packageName">
            <el-input ref="packageName" v-model.trim="taskPackageMergeForm.packageName" placeholder="请输入计划包名称" size="small" clearable maxlength="25" show-word-limit />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addTaskPackageOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="addTaskPackageDetermine">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 计划添加 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="addPlanOpen"
      :title="planTitle" width="624px" top="20vh" custom-class="addPlanMerge" size="small">
      <el-form ref="planForm" :model="planForm" :rules="rules" label-width="120px" label-position="top"
        :disabled="planTitle=='查看计划'" size="small">
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="计划名称:" prop="taskName">
              <el-input ref="taskName" v-model="planForm.taskName" size="small" placeholder="请输入计划名称" maxlength="40" show-word-limit>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8" style="">
            <el-form-item label="工期(天):" prop="planSchedule">
              <el-input v-model="planForm.planSchedule" size="small" placeholder="请输入工期">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="标准工期" prop="standardSchedule">
              <el-input v-model="planForm.standardSchedule" placeholder="请输入标准工期" maxlength="5" size="small">
                <template slot="append">
                  天
                </template>
              </el-input>
              <span slot="error" class="item-error">
                <span>必须输入正整数或者保留一位小数</span>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="关联流程:" prop="flowTempId">
              <el-select v-model="planForm.flowTempId" placeholder="请选择" size="small">
                <el-option v-for="item in flowGroupList" :key="item.flowDefinitionId" :label="item.flowName" :value="item.flowDefinitionId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计划类型">
              <el-tree-select v-model="planForm.taskTypeObj" :options="taskTypeTreeData" :props="taskTypeTreeProps" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="专业:" prop="originalSpecId">
              <el-select v-model="planForm.originalSpecId" placeholder="请选择" size="small" multiple @change="filterRoleList('')">
                <el-option v-for="item in specList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="责任岗位" prop="originalRoleId">
              <el-select v-model="planForm.originalRoleId" filterable multiple placeholder="请选择" size="small">
                <el-option v-for="(item, index) in roleList" :key="index" :label="item.roleName" :value="item.roleId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="里程碑:" prop="isMilestone">
              <el-radio-group v-model="planForm.isMilestone">
                <el-radio :label="shi">是</el-radio>
                <el-radio :label="no">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="immediateTask">
          <div class="immediateTaskTop">
            <div class="immediateTaskTopLeft">
              <p></p>
              <span>紧前计划</span>
            </div>
            <div v-if="planTitle!=='查看计划'" class="immediateTaskTopRight" @click="openjinqian">
              <i class="el-icon-circle-plus-outline"></i>
              <span>添加</span>
            </div>
          </div>
          <div v-if="tasklistkwTJ.length>0" class="immediateTaskList">
            <p class="title">完成-开始：以下计划完成后，当前计划才能开始</p>
            <ul>
              <li v-for="(item,index) in tasklistkwTJ" :key="index">
                <span>{{ index+1 }}. {{ item.taskName }}</span>
                <span><i v-if="planTitle!=='查看计划'" class="el-icon-close" @click="delJQ(item,'1')"></i></span>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="planTitle!='新增计划'" class="immediateTask">
          <div class="immediateTaskTop">
            <div class="immediateTaskTopLeft">
              <p></p>
              <span>紧后计划</span>
            </div>
          </div>
          <div v-if="tasklistJHKW.length>0" class="immediateTaskList">
            <p class="title">完成-开始：当前计划结束后，以下计划才能开始</p>
            <ul>
              <li v-for="(item,index) in tasklistJHKW" :key="index">
                <span>{{ index+1 }}. {{ item.taskName }}</span>
              </li>
            </ul>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addPlanOpen = false">取 消</el-button>
        <el-button v-if="planTitle!=='查看计划'" type="primary" size="small" @click="addPlanDetermine">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 紧前计划添加 -->
    <el-dialog id="eldialogtop2" v-dialogDrag title="紧前计划" :visible.sync="dialogFormVisible2"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="form2" label-position="top" :model="form2" label-width="88px" size="small"
        style="background: #fff; padding: 20px; border-radius: 4px">
        <el-form-item label="请选择紧前计划链接关系">
          <!-- <el-radio v-model="radio" label="1">开始-开始（所关联紧前计划开始后，当前计划才能开始）</el-radio> -->
          <el-radio v-model="radio" label="0">完成-开始（所关联紧前计划完成后，当前计划才能开始）</el-radio>
        </el-form-item>
        <el-form-item label="选择紧前计划" prop="labelColour">
          <div class="lablediv" style="
              border: 1px solid #d9e6fd;
              background: #f6f9fe;
              padding: 15px;
            ">
            <el-input v-model="filterText" clearable placeholder="请输入计划名称" style="width: 300px; margin-bottom: 10px">
            </el-input>
            <el-tree ref="tree" :props="props" default-expand-all show-checkbox :data="tasklistZS"
              :filter-node-method="filterNode" :check-strictly="true" node-key="taskId"
              style="background: #f6f9fe; height: 150px; overflow: auto" @check-change="handleCheckChange">
            </el-tree>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible2 = false">
          取 消
        </el-button>
        <el-button size="small" type="primary" @click="sureaddjinqian('form2')">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import taskPackageservice from "@/CommonDP/service/taskPackage-service";
import flowService from "@/CommonDP/service/flow-service";
import standardTemplateService from "@/CommonDP/service/standardTemplate-service";
import { mapState } from "vuex";
import request from "@/CommonDP/service/progress-service";
import elTreeSelect from "@/CommonDP/components/elTreeSelect";

const newEmptyPlanForm = () => ({
  isMilestone: 0,
  taskName: "",
  taskId: "",
  planSchedule: '',
  originalSpecId: [],
  flowTempId: "",
  taskTypeObj: {},
  standardSchedule: '',
  originalRoleId: [],
  originalRoleName: []
});
export default {
  name: "TaskPackage",
  components: { elTreeSelect },
  data() {
    const standardSchedules = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback();
      } else if (!/^[+]?\d+(\.\d)?$/.test(value)) {
        callback(new Error("必须输入正整数或者保留一位小数"));
      } else {
        callback();
      }
    };
    const planScheduleV = (rule, value, callback) => {
      if (value) {
        const boolean = new RegExp("^[1-9][0-9]*$").test(value);
        if (!boolean) {
          callback(new Error("请输入正整数"));
        } else if (value.length > 5) {
          callback(new Error("工期不能大于5个字符"));
        } else {
          callback();
        }
      } else {
        callback('工期不能为空');
      }
    };
    var taskNameV = (rule, value, callback) => {
      const regExp = new RegExp('[\\\\|/:*<>?"]');
      if (value === "") {
        callback(new Error("计划包名称不能为空"));
      } else if (value.length > 25) {
        callback(new Error("计划包名称不能大于25个字符"));
      } else if (regExp.test(value)) {
        callback(new Error('计划包名称不能包含以下字符:\\ / : * " ? < > |'));
      } else {
        callback();
      }
    };
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      taskPackageList: [],
      cur: "",
      tableData: [],
      addTaskPackageOpen: false,
      taskPackageNameTitle: "新增计划包",
      addPlanOpen: false,
      planTitle: "新增计划",
      planForm: newEmptyPlanForm(),
      rules: {
        taskName: [
          {
            required: true,
            message: "计划名称不能为空",
            trigger: "blur"
          },
          {
            min: 2,
            max: 40,
            message: "长度在 2 到 40 个字符",
            trigger: "blur"
          }],
        planSchedule: [{ required: true, trigger: "blur", validator: planScheduleV }],
        standardSchedule: [{ trigger: "blur", validator: standardSchedules }]
      },
      startDatePickerOptions: {},
      startDateKey: 0,
      endDatePickerOptions: {},
      endDateKey: 0,
      tasklistkkTJ: [], // 已经添加的紧前 开始-开始
      tasklistkwTJ: [], // 已经添加的紧前 完成-开始
      dialogFormVisible2: false,
      form2: {},
      filterText: "",
      tasklistZS: [], // 所有的计划 只要展示勾选 不用一起提交添加
      tasklistGX: [], // 只是勾选的计划
      radio: "0",
      props: {
        label: "taskName",
        children: "nodeList"
      },
      folderData: {},
      parentId: "0",
      input1: "",
      tasklistJHKK: [], // 紧后 开始-开始
      tasklistJHKW: [], // 紧后 完成-开始
      taskId: "",
      shi: 1,
      no: 0,
      specList: [],
      flowGroupList: [],
      taskPackageMergeForm: {
        packageName: ''
      },
      taskPackageMergeRules: {
        packageName: [{ required: true, validator: taskNameV, trigger: "blur" }]
      },
      taskTypeTreeData: [],
      taskTypeTreeProps: {
        parent: "pid", // 父级唯一标识
        value: "id", // 唯一标识
        label: "cnName", // 专业显示
        children: "childNode" // 子级
      },
      roleList: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    tableData1() {
      const searchValue = this.input1;
      if (searchValue) {
        const treeData = this.tableData;
        const handleTreeData = this.handleTreeData(treeData, searchValue);
        this.setExpandRow(handleTreeData);
        return handleTreeData;
      }
      return this.tableData;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    "planForm.originalRoleId"(newValue) {
      if (this.planTitle === '新增计划') {
        this.planForm.originalRoleName = [];
        newValue.forEach(ele => {
          const find = this.roleList.find(({ roleId }) => roleId === ele);
          this.planForm.originalRoleName.push(find);
        });
      }
    }
  },
  created() {
    this.queryTaskPackage();
    this.getFlowSpec();
    this.getAllDic();
  },
  methods: {
    // 点击 表格
    async lookRow(row) {
      this.planTitle = "查看计划";
      this.commonLook(row);
    },
    async commonLook(row) {
      this.taskId = row.taskId;
      this.addPlanOpen = true;
      this.$nextTick(() => {
        this.$refs.planForm.clearValidate();
      });
      const res = await taskPackageservice.taskpackageplandetails(row.taskId);
      this.planForm = res.data;
      this.parentId = res.data.parentId;
      this.planForm.isMilestone = parseInt(res.data.isMilestone);
      this.planForm.originalSpecId = res.data.originalSpecId ? res.data.originalSpecId.split(',') : [];
      await this.filterRoleList('look');
      this.planForm.taskTypeObj = {
        id: res.data.taskType,
        cnName: res.data.taskTypeName
      };
      this.planForm.originalRoleId = res.data.originalRoleId ? res.data.originalRoleId.split(',') : [];
      this.planForm.originalRoleName = res.data.originalRoleName ? res.data.originalRoleName.split(',') : [];
      this.parentId = res.data.parentId;
      this.jiqianxq(row);
    },
    delJQ(item, val) {
      this.$confirm("确定要删除这个计划吗?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          if (val === "0") {
            this.removeByValue(this.tasklistkkTJ, "taskId", item.taskId);
          } else {
            this.removeByValue(this.tasklistkwTJ, "taskId", item.taskId);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeByValue(arr, attr, value) {
      // 数组，属性，属性值
      let index = 0;
      for (const i in arr) {
        if (arr[i][attr] === value) {
          index = i;
          break;
        }
      }
      arr.splice(index, 1);
    },
    childAdd(row) {
      this.parentId = row.taskId;
      this.taskId = row.taskId;
      this.planTitle = "新增计划";
      this.addPlanOpen = true;
      this.$nextTick(() => {
        this.$refs.taskName.focus();
        this.$refs.planForm.clearValidate();
      });
      this.planForm = newEmptyPlanForm();
      this.tasklistkkTJ = [];
      this.tasklistkwTJ = [];
      this.tasklistJHKK = [];
      this.tasklistJHKW = [];
      this.tasklistGX = [];
    },
    async tableMove(row, val) {
      let successMessage;
      val === "0" ? (successMessage = "上移成功") : (successMessage = "下移成功");
      try {
        await taskPackageservice.taskpackagemove(row.taskId, val);
        this.$message.success(`${successMessage}`);
        this.taskpackagelist();
      } catch (error) {
        console.log(error, "移动");
      }
    },
    // 升级
    upgrade(rows, val) {
      if (rows.afterTaskName || rows.preTaskName) {
        this.$confirm("当前计划已关联其他计划，进行升级操作后，关联关系将自动丢失，是否确认升级？", "升级", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(() => {
            this.relegation(rows, val);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.relegation(rows, val);
      }
    },
    // 降级
    demotion(rows, val) {
      if (rows.afterTaskName || rows.preTaskName) {
        this.$confirm("当前计划已关联其他计划，进行降级操作后，关联关系将自动丢失，是否确认降级？", "升级", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(() => {
            this.relegation(rows, val);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.relegation(rows, val);
      }
    },
    delrow(item) {
      this.$confirm("确定要删除这个计划吗?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(async () => {
          const _this = this;
          await taskPackageservice.taskpackagedeleteplan(item.taskId);
          _this.$message.success("删除成功");
          _this.taskpackagelist();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async editrow(item) {
      this.planTitle = "编辑计划";
      this.commonLook(item);
    },
    jiqianxq(item) {
      taskPackageservice.taskpackagerelationtaskList(item.taskId).then((res) => {
        this.tasklistkkTJ = [];
        this.tasklistkwTJ = [];
        for (let i = 0; i < res.data.preTaskList.length; i++) {
          if (res.data.preTaskList[i].relaStatus === "1") {
            this.tasklistkkTJ.push(res.data.preTaskList[i]);
          } else {
            this.tasklistkwTJ.push(res.data.preTaskList[i]);
          }
        }
        this.tasklistJHKK = [];
        this.tasklistJHKW = [];
        for (let i = 0; i < res.data.afterTaskList.length; i++) {
          if (res.data.afterTaskList[i].relaStatus === "1") {
            this.tasklistJHKK.push(res.data.afterTaskList[i]);
          } else {
            this.tasklistJHKW.push(res.data.afterTaskList[i]);
          }
        }
      });
    },
    async relegation(rows, val) {
      let successMessage;
      val === "0" ? (successMessage = "升级成功") : (successMessage = "降级成功");
      try {
        await taskPackageservice.taskpackageupAndDown(rows.taskId, val);
        this.$message.success(`${successMessage}`);
        this.taskpackagelist();
      } catch (error) {
        console.log(error, "升级降级");
      }
    },
    sureaddjinqian() {
      this.dialogFormVisible2 = false;
      if (this.radio === "1") {
        for (let i = 0; i < this.tasklistGX.length; i++) {
          this.tasklistkkTJ.push(this.tasklistGX[i]);
        }
      } else {
        for (let c = 0; c < this.tasklistGX.length; c++) {
          this.tasklistkwTJ.push(this.tasklistGX[c]);
        }
      }
    },
    //  树形表格过滤
    handleTreeData(treeData, searchValue) {
      if (!treeData || treeData.length === 0) {
        return [];
      }
      const array = [];
      for (let i = 0; i < treeData.length; i += 1) {
        let match = false;
        for (const pro in treeData[i]) {
          if (pro === "taskName") {
            if (typeof treeData[i][pro] === "string") {
              match |= treeData[i][pro].includes(searchValue);
              if (match) break;
            }
          }
        }
        if (this.handleTreeData(treeData[i].nodeList, searchValue).length > 0 || match) {
          array.push({
            ...treeData[i],
            nodeList: this.handleTreeData(treeData[i].nodeList, searchValue)
          });
        }
      }
      return array;
    },
    // 将过滤好的树形数据展开
    setExpandRow(handleTreeData) {
      if (handleTreeData.length) {
        for (const i of handleTreeData) {
          if (i.nodeList.length) {
            this.setExpandRow(i.nodeList);
          }
        }
      }
    },
    // 勾选计划
    handleCheckChange(data, checked) {
      if (checked) {
        this.tasklistGX.push(data);
      } else {
        this.removeByValue(this.tasklistGX, "taskId", data.taskId);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.taskName.indexOf(value) !== -1;
    },
    sumSchedule(date1, date2) {
      const sdate = new Date(date1);
      const now = new Date(date2);
      const days = now.getTime() - sdate.getTime() + 86400000;
      const day = Math.abs(parseInt(days / (1000 * 60 * 60 * 24)));
      return day || "";
    },
    queryTaskPackage(data) {
      taskPackageservice.taskpackagetypelist(this.enterpriseId).then((res) => {
        this.taskPackageList = res.data;
        this.folderData = {};
        if (res.data[0]) {
          if (!data) {
            this.cur = "";
            this.cur = res.data[0].packageId;
            this.folderData = res.data[0];
            this.taskpackagelist();
          }
        }
      });
    },
    // 计划ist
    taskpackagelist() {
      const data = {
        packageId: this.cur,
        taskName: this.input1
      };
      taskPackageservice.taskpackagelist(data).then((res) => {
        this.tableData = res.data;
      });
    },
    clickLi(item) {
      this.cur = item.packageId;
      this.folderData = item;
      this.taskpackagelist();
    },
    toRelease() {
      this.parentId = "0";
      this.taskId = "0";
      this.planTitle = "新增计划";
      this.addPlanOpen = true;
      this.$nextTick(() => {
        this.$refs.taskName.focus();
        this.$refs.planForm.clearValidate();
      });
      this.planForm = newEmptyPlanForm();
      this.tasklistkkTJ = [];
      this.tasklistkwTJ = [];
      this.tasklistJHKK = [];
      this.tasklistJHKW = [];
      this.tasklistGX = [];
    },
    addTaskPackage() {
      this.addTaskPackageOpen = true;
      this.$nextTick(() => {
        this.$refs.packageName.focus();
        this.$refs.taskPackageMergeForm.clearValidate();
      });
      this.taskPackageMergeForm.packageName = "";
      this.taskPackageNameTitle = "新增计划包";
    },
    editTaskPackage() {
      this.addTaskPackageOpen = true;
      this.$refs.taskPackageMergeForm.clearValidate();
      this.taskPackageMergeForm.packageName = "";
      this.taskPackageNameTitle = "编辑计划包";
      this.taskPackageMergeForm.packageName = this.folderData.packageName;
    },
    async addTaskPackageDetermine() {
      this.$refs.taskPackageMergeForm.validate(async (valid) => {
        if (valid) {
          const packageName = this.taskPackageMergeForm.packageName;
          const enterpriseId = this.enterpriseId;
          if (this.taskPackageNameTitle === "新增计划包") {
            const data = { packageName, enterpriseId };
            await taskPackageservice.taskpackagetypeinsert(data);
            this.$message.success("新建成功");
          } else {
            const packageId = this.folderData.packageId;
            const data = { packageName, packageId, enterpriseId };
            await taskPackageservice.taskpackagetypeedit(data);
            this.$message.success("编辑成功");
          }
          this.queryTaskPackage();
          this.addTaskPackageOpen = false;
        } else {
          return false;
        }
      });
    },
    delTaskPackage(item) {
      this.$confirm("您是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await taskPackageservice.taskpackagetypedelete(item.packageId);
          this.$message.success("删除成功");
          this.cur = '';
          this.queryTaskPackage();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async moveTaskPackage(item, falge, index) {
      // 如果是上移 index等于0就提示
      // 如果是下移 index等于length-1就提示
      if (falge === 1 && index !== 0) {
        const messageSuccess = "上移成功";
        const formData = new FormData();
        formData.append("moveFlag", falge);
        formData.append("packageId", item.packageId);
        await taskPackageservice.taskPackageTypeMove(formData);
        this.$message.success(`${messageSuccess}`);
        this.queryTaskPackage(1);
      } else if (falge === 2 && index !== this.taskPackageList.length - 1) {
        const messageSuccess = "下移成功";
        const formData = new FormData();
        formData.append("moveFlag", falge);
        formData.append("packageId", item.packageId);
        await taskPackageservice.taskPackageTypeMove(formData);
        this.$message.success(`${messageSuccess}`);
        this.queryTaskPackage(1);
      } else {
        let messageW;
        falge === 1 ? (messageW = "禁止上移") : (messageW = "禁止下移");
        this.$message.warning(`${messageW}`);
      }
    },
    addPlanDetermine() {
      this.$refs.planForm.validate(async (valid) => {
        if (valid) {
          const relationTaskList = [];
          for (let a = 0; a < this.tasklistkkTJ.length; a++) {
            const ddd = {
              taskId: this.tasklistkkTJ[a].taskId,
              taskName: this.tasklistkkTJ[a].taskName,
              relaStatus: "1"
            };
            relationTaskList.push(ddd);
          }
          for (let b = 0; b < this.tasklistkwTJ.length; b++) {
            const dddd = {
              taskId: this.tasklistkwTJ[b].taskId,
              taskName: this.tasklistkwTJ[b].taskName,
              relaStatus: "0"
            };
            relationTaskList.push(dddd);
          }
          const originalSpecId = this.planForm.originalSpecId.toString();
          const taskTypeName = this.planForm.taskTypeObj.cnName;
          const taskType = this.planForm.taskTypeObj.id;
          const originalRoleId = this.planForm.originalRoleId.join(",");
          const originalRoleName = this.planForm.originalRoleName.map(({ roleName }) => roleName).join(",");
          const data = {
            packageId: this.cur,
            parentId: this.parentId,
            isMilestone: this.planForm.isMilestone, // 0是计划 1是里程碑
            relationTaskList: relationTaskList,
            planSchedule: this.planForm.planSchedule,
            taskName: this.planForm.taskName,
            originalSpecId,
            flowTempId: this.planForm.flowTempId,
            taskTypeName,
            taskType,
            standardSchedule: this.planForm.standardSchedule,
            originalRoleId,
            originalRoleName
          };
          if (this.planTitle === "新增计划") {
            console.log(data, "添加");
            await taskPackageservice.taskpackageinsertplan(data);
            this.$message.success("添加成功");
          } else {
            const params = {
              taskId: this.planForm.taskId,
              ...data
            };
            console.log(data, "修改");
            await taskPackageservice.taskpackageeditplan(params);
            this.$message.success("修改成功");
          }
          this.addPlanOpen = false;
          this.taskpackagelist();
        } else {
          return false;
        }
      });
    },
    openjinqian() {
      this.dialogFormVisible2 = true;
      this.form2 = {};
      this.radio = "0";
      this.tasklistGX = [];
      taskPackageservice.taskpackagetasktreelist(this.cur).then((res) => {
        for (let t = 0; t < res.data.length; t++) {
          this.$set(res.data[t], "disabled", false);
          for (let a = 0; a < this.tasklistkkTJ.length; a++) {
            if (res.data[t].taskId === this.tasklistkkTJ[a].taskId) {
              this.$set(res.data[t], "disabled", true);
            }
          }
          for (let v = 0; v < this.tasklistkwTJ.length; v++) {
            if (res.data[t].taskId === this.tasklistkwTJ[v].taskId) {
              this.$set(res.data[t], "disabled", true);
            }
          }
          for (let b = 0; b < this.tasklistJHKK.length; b++) {
            if (res.data[t].taskId === this.tasklistJHKK[b].taskId) {
              this.$set(res.data[t], "disabled", true);
            }
          }
          for (let c = 0; c < this.tasklistJHKW.length; c++) {
            if (res.data[t].taskId === this.tasklistJHKW[c].taskId) {
              this.$set(res.data[t], "disabled", true);
            }
          }
        }
        console.log(res.data, "[[[[");
        this.tasklistZS = res.data;
        this.filterArray(this.tasklistZS, this.taskId);
      });
    },
    filterArray(data, taskId) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].taskId === taskId) {
          data[i].disabled = true;
          this.filterArray(data, data[i].parentId);
        }
      }
      this.tasklistZS = this.filterArray1(data, "0");
    },
    filterArray1(data, parentId) {
      const tree = [];
      let temp;
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentId === parentId) {
          const obj = data[i];
          temp = this.filterArray1(data, data[i].taskId);
          if (temp.length > 0) {
            obj.nodeList = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },
    async getFlowSpec() {
      const resGroup = await flowService.downList(this.enterpriseId);
      this.flowGroupList = resGroup.data;
      const resSpec = await standardTemplateService.getSpecTree(this.enterpriseId);
      this.specList = resSpec.data;
    },
    async getAllDic() {
      const res = await request.queryTaskTypeTree();
      this.taskTypeTreeData = res.data.childNode || [];
    },
    async filterRoleList(val) {
      if (!val) {
        this.planForm.originalRoleId = [];
        this.planForm.originalRoleName = [];
      }
      this.roleList = [];
      this.$forceUpdate();
      const res = await request.taskpackageroleListSpecChange(this.planForm.originalSpecId);
      this.roleList = res.data;
    }
  }
};
</script>

<style lang="scss" scoped>
.taskPackage {
  height: 100%;
  display: flex;
  flex-direction: column;
  .top {
    color: var(--key-color);
    font-size: 16px;
    padding: var(--middle-space) var(--big-space);
    border-bottom: 1px solid #e5e8f1;
    font-weight: 700;
  }
  .content {
    height: 1px;
    flex: 1 0 1px;
    display: flex;
    .contentLeft {
      width: 224px;
      height: 100%;
      border-right: 1px solid #e5e8f1;
      display: flex;
      flex-direction: column;
      .contentLeftTop {
        border-bottom: 1px solid #e5e8f1;
        padding: var(--middle-space) var(--big-space);
        p {
          width: 100%;
          height: 34px;
          line-height: 34px;
          background: #edf2fd;
          color: #346ffa;
          text-align: center;
          border-radius: 2px;
          cursor: pointer;
        }
      }
      .contentLeftLi {
        width: 224px;
        height: 1px;
        flex: 1 0 1px;
        overflow-y: auto;
        li {
          height: 32px;
          line-height: 32px;
          cursor: pointer;
          position: relative;
          margin-top: 10px;
          color: var(--key-color);
          text-align: center;

          /deep/ .el-popover__reference {
            height: 12px !important;
            width: 12px !important;
            position: absolute;
            top: 0px;
          }
          .packageName {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 146px;
            display: inline-block;
          }
          .operation {
            display: inline-block;
            vertical-align: top;
            .el-icon-more {
              position: absolute;
              top: 10px;
            }
          }
        }

        li:hover {
          background: rgba(38, 95, 206, 0.09);
        }

        .active {
          background: rgba(38, 95, 206, 0.09);
        }
      }
    }
    .contentRight {
      // width:100%;
      width: calc(100% - 224px);
      display: flex;
      flex-direction: column;
      .contentRightTop {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: var(--middle-space) var(--big-space);
      }
      .contentRightTable {
        height: 1px;
        flex: 1 0 1px;
        padding: 0 var(--big-space) var(--middle-space);
        /deep/ .el-icon-ziji {
          background: url("../../../../assets/progress/add.png") no-repeat;
          width: 20px;
          height: 20px;
        }

        /deep/ .el-icon-ziji:before {
          content: "替";
          font-size: 13px;
          visibility: hidden;
        }
        /deep/ .el-icon-edit {
          background: url("../../../../assets/progress/edit.png") no-repeat;
          width: 20px;
          height: 20px;
        }

        /deep/ .el-icon-edit:before {
          content: "替";
          font-size: 13px;
          visibility: hidden;
        }
        /deep/ .el-icon-look {
          background: url("../../../../assets/progress/detail.png") no-repeat;
          width: 20px;
          height: 20px;
        }

        /deep/ .el-icon-look:before {
          content: "替";
          font-size: 13px;
          visibility: hidden;
        }
        /deep/ .el-icon-del {
          background: url("../../../../assets/progress/del.png") no-repeat;
          width: 20px;
          height: 20px;
        }

        /deep/ .el-icon-del:before {
          content: "替";
          font-size: 13px;
          visibility: hidden;
        }
        /deep/ .el-icon-shangyi {
          background: url("../../../../assets/progress/shangyi.png") no-repeat;
          width: 20px;
          height: 20px;
        }

        /deep/ .el-icon-shangyi:before {
          content: "替";
          font-size: 13px;
          visibility: hidden;
        }
        /deep/ .el-icon-xiayi {
          background: url("../../../../assets/progress/xiayi.png") no-repeat;
          width: 20px;
          height: 20px;
        }

        /deep/ .el-icon-xiayi:before {
          content: "替";
          font-size: 13px;
          visibility: hidden;
        }
        /deep/ .el-icon-shengji {
          background: url("../../../../assets/progress/shengji.png") no-repeat;
          width: 20px;
          height: 20px;
        }

        /deep/ .el-icon-shengji:before {
          content: "替";
          font-size: 13px;
          visibility: hidden;
        }
        /deep/ .el-icon-jiangji {
          background: url("../../../../assets/progress/jiangji.png") no-repeat;
          width: 20px;
          height: 20px;
        }

        /deep/ .el-icon-jiangji:before {
          content: "替";
          font-size: 13px;
          visibility: hidden;
        }
        ::v-deep(.el-table__row:not([class*="el-table__row--level-"])) {
          td:first-child {
            padding-left: 23px;
          }
        }
      }
    }
  }
  .addTaskPackageMerge {
    .packageName {
      padding-bottom: 25px;
    }
  }
  ::v-deep .addPlanMerge {
    .el-dialog__body {
      padding: var(--middle-space) var(--big-space) !important;
      .el-form-item {
        margin-bottom: 10px;
        /deep/ .el-form-item__label {
          line-height: 34px !important;
        }
        /deep/ .el-form-item__content {
          line-height:13px;
        }
        .item-error{
          display: inline-block;
          color: #F56C6C;
          font-size: 12px;
        }
      }
      .immediateTask {
        .immediateTaskTop {
          padding: 9px 0px;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #d4d9ec;
          .immediateTaskTopLeft {
            color: var(--theme-color);
            p {
              width: 2px;
              height: 14px;
              background: var(--theme-color);
              border-radius: 1px;
              display: inline-block;
              margin-top: 4px;
              margin-right: 3.5px;
            }
            span {
              font-size: 16px;
              vertical-align: top;
            }
          }
          .immediateTaskTopRight {
            color: var(--theme-color);
            cursor: pointer;
            i {
              font-size: 14px;
              margin-right: 5px;
            }
            span {
              font-size: 14px;
            }
          }
        }
        .immediateTaskList {
          margin-top: 14px;
          background: rgba(238, 243, 249, 0.73);
          border-radius: 4px;
          padding: 9px 16px 21px 16px;
          width: 100%;
          .title {
            font-size: 14px;
            color: #6872a6;
            border-bottom: 1px solid rgba(212, 217, 236, 0.58);
            padding-bottom: 9px;
          }
          ul {
            padding-left: 14px;
          }
          li {
            color: var(--key-color);
            font-size: 14px;
            height: 38px;
            line-height: 38px;
            border-bottom: 1px solid rgba(212, 217, 236, 0.58);
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }
  #eldialogtop2 {
    /deep/ .el-dialog {
      width: 500px;
    }
    /deep/ .el-dialog__header {
      padding: 15px 20px 15px;
    }
    /deep/ .el-dialog__body {
      background: #f1f2f6;
      padding: 15px 15px;
      padding-bottom: 15px;
      .el-tree-node__content {
        border-bottom: 1px solid #d9e0ea;
        color: #538be6;
      }
    }
    /deep/ .el-dialog__footer {
      padding: 10px 20px 10px;
    }
  }
}
::v-deep .el-input__suffix{
  line-height: 32px;
  right: 9px;
}
</style>
<style lang="scss">
.secondUserIDs {
  min-width: 60px !important;
  width: 60px !important;
  padding: 0px !important;
  font-size: 13px !important;
  cursor: pointer !important;
  .elasticbox {
    width: 60px;
    display: inline-block;
  }
  .elasticbox p {
    text-align: center;
    font-size: 13px;
    height: 21px;
    line-height: 21px;
    margin-top: 5px;
  }
  .elasticbox i {
    padding-right: 5px;
  }
  .elasticbox p:hover {
    background: #ecf5ff;
    color: rgb(24, 144, 255);
  }
  .popper__arrow {
    left: 4px !important;
  }
}
</style>
